import { Link } from 'react-router-dom';

const BRAND_NAME = 'Hooklink';

const LOGO_PATH = `
M555.744141,637.754517
	C549.062866,631.002686 542.379028,624.253357 535.700684,617.498657
	C509.807678,591.309570 483.856476,565.177307 458.098969,538.855591
	C454.811279,535.495850 452.872559,535.617798 449.771729,538.896790
	C443.019196,546.037170 435.863464,552.794434 428.957947,559.792542
	C424.318665,564.494080 424.340088,564.832275 428.857483,569.384033
	C474.872345,615.748657 520.834656,662.165710 566.959900,708.420288
	C585.800781,727.314026 609.310181,736.061096 635.512878,736.450500
	C660.089722,736.815796 682.368591,729.132324 701.164917,712.650574
	C724.748657,691.970764 736.509583,665.652466 736.394592,634.610229
	C736.296692,608.169434 725.886292,585.388733 707.431763,566.421692
	C698.600952,557.345581 689.453308,548.575867 680.698181,539.429077
	C677.780212,536.380615 675.890930,536.526367 673.036011,539.404358
	C662.478088,550.047302 651.676453,560.447937 641.078857,571.052063
	C636,575 626,584 622,593
	C618,604 632,596 644.735718,581.643677
	C662.940613,583.764587 677.471375,592.112915 686.645386,608.045166
	C706.094727,641.822388 686.893005,684.940613 648.718933,693.165405
	C628.189209,697.588684 609.992615,691.763184 594.947754,677.310059
	C581.734436,664.616394 569.117371,651.302002 555.744141,637.754517
M571.748108,385.806122
	C572.340271,386.391541 572.920227,386.989960 573.527039,387.559784
	C576,392 583,400 589,401
	C596,402 594,391 589,384
	C585,379 582,377 581.230286,376.327576
	C586.879700,348.663147 613.154480,328.799316 643.637573,332.651886
	C673.243652,336.393616 695.482117,362.105225 694.139343,391.766937
	C693.364502,408.882568 685.715088,422.966827 673.619934,434.912354
	C642.447937,465.698853 611.403259,496.614197 580.262329,527.432129
	C566.764160,540.790222 553.221375,554.105042 539.547791,567.282837
	C536.156372,570.551270 535.953857,572.911133 539.507263,576.247803
	C546.910461,583.199463 554.081787,590.409058 561.124634,597.728149
	C563.982483,600.698059 565.877441,600.599976 568.792297,597.688599
	C587.059875,579.443298 605.550842,561.421875 623.871765,543.229675
	C652.241943,515.058777 681.163574,487.407928 708.706299,458.447601
	C745.414062,419.850616 746.724426,354.947449 703.928528,316.341034
	C670.384521,286.080780 620.694275,281.562256 582.603638,305.779480
	C565.839294,316.437927 553.351074,331.900452 539.228699,345.513824
	C536.233948,348.400635 537.405151,350.969177 540.040771,353.611847
	C550.508545,364.107483 560.847290,374.731720 571.748108,385.806122
M296.456482,672.065186
	C297.255249,673.897034 298.043091,675.733704 298.854340,677.559998
	C320.911652,727.213440 377.838135,748.749756 427.549408,729.155518
	C453.981140,718.737244 470.431061,696.655823 489.734924,678.022461
	C486.135468,671.590820 444,628 434,620
	C422,610 430,636 444.825439,651.641235
	C437.896729,682.120728 405.107117,701.309570 374.971283,692.590454
	C348.759003,685.006531 332.347595,664.087036 332.132355,636.030334
	C332.002716,619.126892 338.923218,604.649353 350.862213,592.699463
	C364.990753,578.557800 379.226929,564.523682 393.417511,550.444092
	C424.282806,519.820374 455.098511,489.146179 486.084961,458.645508
	C489.528992,455.255463 489.625671,453.188934 486.090759,449.910553
	C479.621887,443.910980 473.665741,437.362549 467.306854,431.239258
	C460.181549,424.377930 461.787048,423.433716 453.835236,431.285309
	C409.620758,474.942902 365.150818,518.355469 321.638214,562.705383
	C291.573059,593.349121 283.036713,630.045410 296.456482,672.065186
M305.303192,442.201233
	C316.310913,459.834198 332.672150,472.565826 346.685822,487.448242
	C349.480682,490.416351 351.282745,488.490021 353.242035,486.517670
	C364.750549,474.932251 376.273041,463.360657 387.769745,451.763519
	C392,447 399,438 401,432
	C404,424 396,434 383.980988,445.377228
	C350.691010,443.649261 326.141693,411.732483 333.210571,378.934082
	C338.024200,356.599823 351.268036,341.315826 373.292450,334.579681
	C395.313507,327.844604 415.247894,333.009094 431.389984,348.845123
	C464.572021,381.398041 497.000641,414.718536 529.770386,447.692322
	C542.338440,460.338623 554.961670,472.930450 567.619995,485.486481
	C572.565674,490.392212 572.724243,490.365540 577.550110,485.619415
	C584.083984,479.193481 590.544434,472.692627 597.019226,466.206818
	C601.896973,461.320740 601.929626,460.889313 596.902283,455.826630
	C585.395691,444.239349 573.801697,432.738861 562.305969,421.140839
	C528.406799,386.940125 494.852325,352.390503 460.563019,318.585968
	C430.605438,289.051849 384.130890,281.786865 347.065491,299.812927
	C294.179413,325.533142 273.572327,390.619659 305.303192,442.201233
z`;

/**
 * Hooklink logo icon: two interlinked hooks forming a knot shape.
 */
export function Logo({
  size = 16,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="270 275 480 480"
      fill="none"
      className={className}
      aria-label="Hooklink logo"
    >
      <path fill="currentColor" d={LOGO_PATH} />
    </svg>
  );
}

/**
 * Configurable brand logo + text component.
 * Single source of truth for the Hooklink brand mark across all pages.
 */
export function BrandLogo({
  size = 28,
  textClassName = 'font-display text-xl font-bold tracking-[-0.01em]',
  showText = true,
  link = '/',
  iconClassName = 'text-primary',
  iconWrapperClassName,
  className = '',
}: {
  size?: number;
  textClassName?: string;
  showText?: boolean;
  link?: string;
  iconClassName?: string;
  iconWrapperClassName?: string;
  className?: string;
}) {
  const icon = <Logo size={size} className={iconClassName} />;

  return (
    <Link
      to={link}
      className={`flex items-center gap-2.5 group flex-shrink-0 ${className}`}
    >
      {iconWrapperClassName ? (
        <div className={iconWrapperClassName}>{icon}</div>
      ) : (
        icon
      )}
      {showText && <span className={textClassName}>{BRAND_NAME}</span>}
    </Link>
  );
}
